import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {push, replace} from 'connected-react-router';

import {
  clearRiderAddressDraft,
  editRiderAddressDraft,
  newRiderAddressDraft,
  sendRiderAddressDraft,
  setRiderAddressDraft,
} from 'ondemand/actions/riderAddress';
import {
  getRiderAddresses,
  getRiderAddressDraft,
  getRiderAddressDraftErrors,
} from 'ondemand/selectors';
import {fetchRiderAddressesIfNeeded} from 'ondemand/actions/riderAddress';
import AddressForm from 'ondemand/components/AddressForm';

class AddressEditor extends React.Component {
  static displayName = 'AddressEditor';

  static propTypes = {
    addresses: PropTypes.object,
    addressDraft: PropTypes.object,
    addressDraftErrors: PropTypes.array,
    addressId: PropTypes.string,
    dispatch: PropTypes.func,
    route: PropTypes.object,
  };

  componentDidMount() {
    this.props.dispatch(fetchRiderAddressesIfNeeded())
      .then(() => {
        const {addressId, addresses} = this.props;
        const action =
          addressId ? setRiderAddressDraft(addresses[addressId]) : newRiderAddressDraft();
        return this.props.dispatch(action);
      });
  }

  _handleCancel = () => {
    this.props.dispatch(clearRiderAddressDraft());
    return this.props.dispatch(push('/addresses'));
  };

  _handleChange = (key, value) =>
    this.props.dispatch(editRiderAddressDraft(key, value));

  _handleSave = () =>
    this.props.dispatch(sendRiderAddressDraft(this.props.addressDraft))
      .then(action => {
        if (!action.errors) {
          this.props.dispatch(clearRiderAddressDraft());
          return this.props.dispatch(replace('/addresses'));
        }
        return null;
      });

  render() {
    if (this.props.addressDraft === null) return null;
    return (
      <AddressForm
        address={this.props.addressDraft}
        errors={this.props.addressDraftErrors}
        onCancel={this._handleCancel}
        onChange={this._handleChange}
        onSave={this._handleSave}
        pageDataId={'address-form-container'}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  addresses: getRiderAddresses(state),
  addressDraft: getRiderAddressDraft(state),
  addressDraftErrors: getRiderAddressDraftErrors(state),
  addressId: ownProps.match.params.addressId,
});

export default connect(mapStateToProps)(AddressEditor);



// WEBPACK FOOTER //
// ./src/ondemand/containers/AddressEditor.js